import { customAlphabet } from 'nanoid/non-secure';

export const nanoid = customAlphabet('qwertyuiopasdfghjklzxcvbnm1234567890', 8);
